import _ from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import {
    BANK_LOAD,
    BANK_FAILURE,
    BANK_SUCCESS
} from './bankActions';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case BANK_LOAD:
            newState = {
                ...state,
                bank: null,
                error: null,
                isUpdateSuccess: false
            };

            return _.isEqual(state, newState) ? state : newState;

        case BANK_SUCCESS:
            newState = {
                ...state,
                bank: action.bank
            };

            return _.isEqual(state, newState) ? state : newState;

        case BANK_FAILURE:
            newState = {
                ...state,
                error: action.error
            };

            return _.isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getBankEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'bankInfo')
);

export const getBank = createSelector(
    getBankEntity,
    (entity) => _.get(entity, 'bank')
);

export const getBankName = createSelector(
    getBankEntity,
    (bank) => _.get(bank, 'bankName')
);

export const getBankRoutingNumber = createSelector(
    getBankEntity,
    (bank) => _.get(bank, 'bankRoutingNumber')
);

export const getBankAccountNumber = createSelector(
    getBankEntity,
    (bank) => _.get(bank, 'bankAccountNumber')
);
